import React from 'react';
import Image from 'next/image';
import { toDe } from '@/utilites/sku-operations';
import { ImagesIconsNotificationsBidSvg } from '@/assets/images_icons_notifications.assets';
import { SkuIsBidOwnerProps } from '@/types/props/components/skus';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { SkuEnum } from '@/types/translations/SkuEnum';

const SkuIsBidOwnerMobile = ({ isBidOwner, bidValue }: SkuIsBidOwnerProps) => {
  const { translate } = useTypedTranslation<SkuEnum>('sku');

  if (!isBidOwner) return null;

  return (
    <div className="tw-w-full tw-bg-mint-whisper tw-border tw-border-solid tw-border-mint-frost mx-auto tw-rounded-xl">
      <div className="tw-flex tw-items-center tw-justify-center tw-gap-5 tw-py-2 tw-max-w-80 tw-mx-auto">
        <Image
          src={ImagesIconsNotificationsBidSvg}
          alt="Bid Icon"
          width={32}
          height={32}
        />
        <div>
          <p className="mb-0 tw-font-plusJakartaSans tw-font-bold tw-text-xs-custom tw-text-text">
            {`${translate(SkuEnum['your_current_bid_for_this_item_is'])} ${toDe(bidValue)}`}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SkuIsBidOwnerMobile;
